export default __webpack_public_path__ + "static/media/filter_user_role_blue.cb01c665.svg";